import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GitLabGroup, GitlabClient } from '../httpClients/GitlabClient';
import { QUERY_KEYS } from './consts';

/**
 * Hook to fetch all GitLab groups and subgroups for a given app config.
 * @param {string} appConfigId - The GitLab app config ID
 * @param {Partial<UseQueryOptions<GitLabGroup[], Error>>} options - Additional TanStack Query options
 * @returns {UseQueryResult<GitLabGroup[], Error>} Query result containing the list of GitLab groups
 */
export const useGitlabGroupsQuery = (
  appConfigId: string,
  options: Partial<UseQueryOptions<GitLabGroup[], Error>> = {},
) =>
  useQuery({
    queryKey: [QUERY_KEYS.GITLAB_GROUPS, appConfigId],
    queryFn: () => GitlabClient.getGroups({ appConfigId }),
    ...options,
  });
